import React from "react";

const AutoFormContext = React.createContext("");
export default AutoFormContext;
